/**
 * 全記事の登録テーブル。
 * slug -> 記事メタデータ + Content コンポーネント のマップ。
 *
 * 新規記事を追加するときは:
 *  1. このディレクトリに <slug>.tsx を作成
 *     export const meta = { title, updatedAt };
 *     export function Content() { return <>...</>; }
 *  2. ここで import & 登録
 *  3. GuideToc.ts の TOC_SECTIONS に追加
 */
import type { ComponentType } from "react";

// 個別記事
import * as overview from "./overview.js";
import * as quickStart from "./quick-start.js";
import * as hubspotConnect from "./hubspot-connect.js";
import * as csClientId from "./cs-clientid.js";
import * as propertySetup from "./property-setup.js";
import * as send from "./send.js";
import * as templates from "./templates.js";
import * as recipients from "./recipients.js";
import * as statusSync from "./status-sync.js";
import * as clientIdMgmt from "./clientid-mgmt.js";
import * as notifications from "./notifications.js";
import * as sendLogs from "./send-logs.js";
import * as billing from "./billing.js";
import * as usersRoles from "./users-roles.js";
import * as hubspotReauth from "./hubspot-reauth.js";
import * as bulkProperties from "./bulk-properties.js";
import * as usageLimits from "./usage-limits.js";
import * as faq from "./faq.js";

export interface ArticleMeta {
  title: string;
  updatedAt: string;
  Content: ComponentType;
}

function pack(mod: { meta: { title: string; updatedAt: string }; Content: ComponentType }): ArticleMeta {
  return { title: mod.meta.title, updatedAt: mod.meta.updatedAt, Content: mod.Content };
}

export const ARTICLES: Record<string, ArticleMeta> = {
  // はじめに
  overview: pack(overview),

  // スタートガイド
  "quick-start": pack(quickStart),
  "hubspot-connect": pack(hubspotConnect),
  "cs-clientid": pack(csClientId),
  "property-setup": pack(propertySetup),

  // 機能別ガイド
  send: pack(send),
  templates: pack(templates),
  recipients: pack(recipients),
  "status-sync": pack(statusSync),
  "clientid-mgmt": pack(clientIdMgmt),
  notifications: pack(notifications),
  "send-logs": pack(sendLogs),
  billing: pack(billing),

  // 管理者向けガイド
  "users-roles": pack(usersRoles),
  "hubspot-reauth": pack(hubspotReauth),
  "bulk-properties": pack(bulkProperties),
  "usage-limits": pack(usageLimits),

  // FAQ
  faq: pack(faq),
};
